import DefaultImage from '../assets/defaultImage/default-img.png';
import DefaultImageProduct from '../assets/defaultImage/default-img-product.png';

export const useDefault = {
  getDefaultImage: DefaultImage,
  getDefaultImageProduct: DefaultImageProduct
}